import { useEffect } from 'react';

const APP_NAME =
  (typeof window !== 'undefined' && window.ENV && window.ENV.APP_TITLE) || 'RWK Manager';

/**
 * Setzt den Browser-Tab-Titel passend zur aktuellen Seite.
 *
 * Aufruf am Anfang jeder Seiten-Komponente, z. B. `useDocumentTitle('Anmelden')`.
 * Dargestellt wird "<Seite> – RWK Manager"; ohne Argument nur der App-Name.
 * Der App-Name folgt `window.ENV.APP_TITLE` (siehe public/env.js), sonst
 * "RWK Manager". `title` darf sich ändern (z. B. sobald Daten geladen sind).
 */
export default function useDocumentTitle(title) {
  useEffect(() => {
    const next = title ? `${title} – ${APP_NAME}` : APP_NAME;
    if (document.title !== next) {
      document.title = next;
    }
  }, [title]);
}
